<template>
  <div class="max-w-4xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
    <article class="prose prose-lg max-w-none">
      <h1>{{ $t('privacy.title') }}</h1>

      <p class="text-sm text-gray-500 mb-4">
        最終更新日: 2025年5月28日
      </p>

      <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-8">
        <p class="text-blue-800 font-medium">
          <span class="font-semibold">English follows below</span> / このプライバシーポリシーの英語版は下部に記載しています。<br>
          ただし、原文は日本語版であり、英語版と齟齬がある場合は日本語版が優先されます。また、本ポリシーは日本の法律に基づいて解釈されます。
        </p>
      </div>

      <p>
        anypost.dev（以下、「本サービス」）は、以下のプライバシーポリシーに基づいて運営されます。
      </p>

      <h2>個人情報</h2>
      <p>
        「個人情報」とは、個人情報保護法にいう「個人情報」を指すものとし、生存する個人に関する情報であって、特定の個人を識別できる情報及び当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。
      </p>

      <h2>収集する情報</h2>

      <h3>個人情報</h3>
      <ul>
        <li>投稿先サーバー名（個人を識別可能な可能性が否定できないため記載しています。投稿先サーバーの種別を判定するため、技術的に必要となります。）</li>
      </ul>

      <h3>個人情報以外の情報</h3>
      <ul>
        <li>IPアドレス（Webサーバーの技術的特性により自動的に収集され、アクセス制限等のサービス運営に必要）</li>
        <li>Cookie、User-agentなどブラウザ等から送信されるメタデータ（Webサーバーの技術的特性により自動的に収集される）</li>
      </ul>

      <h2>収集しない情報</h2>
      <ul>
        <li>投稿内容</li>
        <li>ソーシャルメディアのアカウント情報や投稿履歴</li>
      </ul>

      <h2>情報の利用方法</h2>
      <p>
        収集した情報は以下の目的でのみ利用します。利用方法を変更する場合、別に定められるプライバシーポリシーの変更に従って、事前に公表します。
      </p>
      <ul>
        <li>アクセス制限（ただし、攻撃を受けている場合など、サービスの正当な運営に必要不可欠なものに限る）</li>
        <li>ユーザからの問い合わせ対応</li>
        <li>その他、上記に付随する目的</li>
      </ul>

      <h2>個人情報の第三者への提供</h2>
      <p>個人情報については、以下を除き、第三者への提供を行いません。</p>
      <ul>
        <li>人の生命または財産の保護のために必要で、かつ本人の同意を得ることが著しく困難である場合</li>
        <li>公衆衛生の向上または児童の健全な育成の推進のために必要で、かつ本人の同意を得ることが著しく困難である場合</li>
        <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要があり、かつ本人の同意を得ることにより当該事務の遂行に多大な支障を及ぼす恐れがある場合</li>
      </ul>

      <h2>個人情報の開示</h2>
      <p>
        本人からその個人情報の開示を求められたとき、本人に対し、遅延無く現実的に可能な範囲での努力を行い、これを開示します。開示の請求は、本ページ下部の「お問い合わせ先」から請求することとします。ただし、開示することにより以下のいずれかに該当する場合、その一部または全部を開示しないこともあります。
      </p>
      <ul>
        <li>本人または第三者の生命・身体・財産その他の権利利益を害するおそれがある場合</li>
        <li>本サービスの正当な運営に著しい支障を及ぼすおそれがある場合</li>
        <li>開示により法令に違反するおそれがある場合</li>
      </ul>
      <p>
        なお、開示に際しては、1件1,000円の事務手数料を申し受けます。
      </p>

      <h2>個人情報の訂正・削除・利用停止</h2>
      <p>
        本人から、個人情報が誤った情報であるという理由により、その訂正を求められた場合、遅滞なく現実的に可能な範囲での努力を通じて必要な調査を行います。また、本人から、個人情報がプライバシーポリシーで定められた範囲を超えて取り扱われているという理由・不正の手段により取得されたものであるという理由により、その利用の停止または消去を求められた場合、遅滞なく現実的に可能な範囲での努力を通じて必要な調査を行います。いずれの場合も、本サービスの運営者がその請求に応じる必要があると判断した場合は訂正・削除・利用停止を行います。また、いずれの場合も、その請求に応じられない場合は、その通知を行います。なお、本項で定める訂正・削除・利用停止の請求は、本ページ下部の「お問い合わせ先」から請求することとします。
      </p>

      <h2>Cookieの利用</h2>
      <p>
        本サービスでは、ユーザーの許可があった場合には、ユーザー体験の向上のために必要最小限のCookieを使用します。具体的には、以下の用途に利用しています。
      </p>
      <ul>
        <li>言語設定およびサイトの標準機能（投稿先サーバーの記憶）のため</li>
        <li>Google Analytics によるユーザ体験の確認と向上を図るため</li>
      </ul>

      <h2>Google Analyticsの利用</h2>
      <p>
        本サービスでは、ユーザーの許可があった場合に限り、サービス改善のため、Google社による Google Analytics を使用しています。ただし、データは匿名で収集されており、個人を特定できるものはありません。Google Analytics により収集された情報は、Google社のプライバシーポリシーに基づき管理されます。
      </p>
      <p>
        Google Analyticsを無効にしたい場合は、Cookieの設定を変更するか、Google Analytics オプトアウト アドオンをご利用ください。
      </p>

      <h2>プライバシーポリシーの変更</h2>
      <p>
        プライバシーポリシーは、ユーザに通知することなく変更できるものとします。新しいプライバシーポリシーは、本ウェブサイトに掲載直後から効力を生じるものとします。
      </p>

      <h2>お問い合わせ先</h2>
      <p>
        プライバシーに関する権利の行使には、<a href="https://docs.google.com/forms/d/e/1FAIpQLSdernD1pHLicKx8Xbyjic1BNsl2idC4yUO8CBBeVGIcVVfYhw/viewform" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:text-blue-800 underline">Googleフォーム</a> をご利用ください。
      </p>
      <p>
        その他の一般的な問い合わせについては、<a href="https://highemerly.net/#contact" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:text-blue-800 underline">お問い合わせページ</a> よりいずれかの方法でお問い合わせください。
      </p>

      <!-- English Version -->
      <div class="mt-16 pt-8 border-t border-gray-300">
        <h1 class="text-3xl font-bold text-gray-900 mb-6">Privacy Policy (English)</h1>

        <p class="text-sm text-gray-500 mb-8">
          Last Updated: May 28, 2025
        </p>

        <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-8">
          <p class="text-yellow-800 font-medium">
            <span class="font-semibold">Notice:</span> This English version is provided for convenience only. The original Japanese version takes precedence in case of any discrepancies. This policy is governed by Japanese law.
          </p>
        </div>

        <p>
          anypost.dev (hereinafter referred to as "this Service") is operated based on the following privacy policy.
        </p>

        <h2 class="text-2xl font-semibold text-gray-900 mt-8 mb-4">Personal Information</h2>
        <p>
          "Personal Information" refers to "personal information" as defined in the Personal Information Protection Act, which means information about living individuals that can identify a specific individual and information that can identify a specific individual from that information alone (personal identification information).
        </p>

        <h2 class="text-2xl font-semibold text-gray-900 mt-8 mb-4">Information We Collect</h2>

        <h3 class="text-xl font-medium text-gray-900 mt-6 mb-3">Personal Information</h3>
        <ul class="list-disc list-inside mb-4 space-y-2 ml-4">
          <li>Destination server names (listed because the possibility of personal identification cannot be ruled out. This is technically necessary to determine the type of destination server.)</li>
        </ul>

        <h3 class="text-xl font-medium text-gray-900 mt-6 mb-3">Non-Personal Information</h3>
        <ul class="list-disc list-inside mb-4 space-y-2 ml-4">
          <li>IP addresses (automatically collected due to technical characteristics of web servers, necessary for service operations such as access restrictions)</li>
          <li>Cookies, User-agent, and other metadata sent from browsers (automatically collected due to technical characteristics of web servers)</li>
        </ul>

        <h2 class="text-2xl font-semibold text-gray-900 mt-8 mb-4">Information We Do Not Collect</h2>
        <ul class="list-disc list-inside mb-4 space-y-2 ml-4">
          <li>Post content</li>
          <li>Social media account information and posting history</li>
        </ul>

        <h2 class="text-2xl font-semibold text-gray-900 mt-8 mb-4">How We Use Information</h2>
        <p>
          The collected information is used only for the following purposes. If we change the usage methods, we will announce in advance according to changes to this privacy policy.
        </p>
        <ul class="list-disc list-inside mb-4 space-y-2 ml-4">
          <li>Access restrictions (limited to those essential for legitimate service operations, such as when under attack)</li>
          <li>Responding to user inquiries</li>
          <li>Other purposes incidental to the above</li>
        </ul>

        <h2 class="text-2xl font-semibold text-gray-900 mt-8 mb-4">Third-Party Provision of Personal Information</h2>
        <p>We do not provide personal information to third parties except in the following cases:</p>
        <ul class="list-disc list-inside mb-4 space-y-2 ml-4">
          <li>When necessary for protecting human life or property and obtaining consent is extremely difficult</li>
          <li>When necessary for improving public health or promoting sound development of children and obtaining consent is extremely difficult</li>
          <li>When cooperation is necessary for national agencies, local governments, or their commissioned parties to perform statutory duties, and obtaining consent may significantly hinder the performance of such duties</li>
        </ul>

        <h2 class="text-2xl font-semibold text-gray-900 mt-8 mb-4">Disclosure of Personal Information</h2>
        <p>
          When requested by an individual to disclose their personal information, we will make realistic efforts to disclose it without delay. Disclosure requests should be made through the "Contact Information" at the bottom of this page. However, we may not disclose some or all information if any of the following applies:
        </p>
        <ul class="list-disc list-inside mb-4 space-y-2 ml-4">
          <li>Risk of harming the life, body, property, or other rights and interests of the individual or third parties</li>
          <li>Risk of significantly hindering legitimate service operations</li>
          <li>Risk of violating laws and regulations through disclosure</li>
        </ul>
        <p>
          An administrative fee of 1,000 yen per case will be charged for disclosure.
        </p>

        <h2 class="text-2xl font-semibold text-gray-900 mt-8 mb-4">Correction, Deletion, and Suspension of Use of Personal Information</h2>
        <p>
          When an individual requests correction of personal information on the grounds that it is incorrect, we will conduct necessary investigations through realistic efforts without delay. When an individual requests suspension or deletion of use on the grounds that personal information is being handled beyond the scope defined in this privacy policy or was obtained through improper means, we will conduct necessary investigations through realistic efforts without delay. In either case, if the service operator determines that it is necessary to respond to the request, we will perform correction, deletion, or suspension of use. In either case, if we cannot respond to the request, we will notify accordingly. Requests for correction, deletion, or suspension of use as defined in this section should be made through the "Contact Information" specified separately.
        </p>

        <h2 class="text-2xl font-semibold text-gray-900 mt-8 mb-4">Use of Cookies</h2>
        <p>
          This service uses minimal necessary cookies to improve user experience when users give permission. Specifically, we use them for the following purposes:
        </p>
        <ul class="list-disc list-inside mb-4 space-y-2 ml-4">
          <li>Language settings and standard site functions (remembering destination servers)</li>
          <li>Google Analytics for confirming and improving user experience</li>
        </ul>

        <h2 class="text-2xl font-semibold text-gray-900 mt-8 mb-4">Use of Google Analytics</h2>
        <p>
          This service uses Google Analytics by Google Inc. for service improvement only when users give permission. However, data is collected anonymously and cannot identify individuals. Information collected by Google Analytics is managed according to Google's privacy policy.
        </p>
        <p>
          If you wish to disable Google Analytics, please change your cookie settings or use the Google Analytics opt-out add-on.
        </p>

        <h2 class="text-2xl font-semibold text-gray-900 mt-8 mb-4">Changes to Privacy Policy</h2>
        <p>
          This privacy policy may be changed without notice to users. The new privacy policy will take effect immediately upon posting on this website.
        </p>

        <h2 class="text-2xl font-semibold text-gray-900 mt-8 mb-4">Contact Information</h2>
        <p>
          For exercising privacy rights, please use our <a href="https://docs.google.com/forms/d/e/1FAIpQLSdernD1pHLicKx8Xbyjic1BNsl2idC4yUO8CBBeVGIcVVfYhw/viewform" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:text-blue-800 underline">Google Form</a>.
        </p>
        <p>
          For other general inquiries, please contact us through any of the methods available on our <a href="https://highemerly.net/#contact" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:text-blue-800 underline">contact page</a>.
        </p>
      </div>
    </article>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t: $t } = useI18n()
</script>
